import React from 'react';
import { Box, makeStyles, Breadcrumbs, Theme } from '@material-ui/core';
import EditPencil from '../../components/EditPencil';
import IndustryBullet from '../../components/IndustryBullet';
import { EntrepreneurProfileBody, Industry } from '../../types/types';
import CompanyLogoImage from '../../components/CompanyLogoImage';
import { useEntContext } from '../../contexts';
import { StyledText } from '../../components/StyledText';
import { getDisplayedLocation } from '../../lib';
import DetectLinks from '../../components/DetectLinks';
import { tbd } from '../../lib/utils';


const useStyles = makeStyles((theme: Theme) => ({
  root: {
    maxWidth: 928,
    padding: '20px 20px 0 20px',
    [theme.breakpoints.up('md')]: {
      padding: '35px 35px 0 35px'
    },
    position: 'relative'
  },
  locationAndModelBox: {
    alignSelf: 'flex-end',
    padding: '10px 10px 0px 10px'
  }
}));

interface EntrepreneurIntroPanelProps {
  introBody: EntrepreneurProfileBody
  editable: boolean
  openEdit: () => void
}

const EntrepreneurIntroPanel: React.FC<EntrepreneurIntroPanelProps> = ({
  introBody, editable, openEdit
}) => {
  const styles = useStyles();

  const { geography, marketModelList, intro, industryList, id } = introBody;
  const { getLogoImageProvider } = useEntContext();
  const logoImageProvider = getLogoImageProvider(id);

  return (
    <Box className={styles.root}>
      {editable && <EditPencil onClick={openEdit} style={{ top: 10, right: 10, position: 'absolute' }} />}
      <Box display='flex' flexWrap='wrap' justifyContent='space-between' padding='0 0 35px 0'>
        <CompanyLogoImage logoImageProvider={logoImageProvider} />
        <Breadcrumbs separator='|' aria-label='breadcrumb' className={styles.locationAndModelBox}>
          <StyledText color={geography && geography.worldRegion ? 'primary' : 'textSecondary'} variant='overline' style={{ textTransform: 'capitalize' }}>
            {getDisplayedLocation(geography)}
          </StyledText>
          <StyledText color={marketModelList.length ? 'primary' : 'textSecondary'} variant='overline'>{marketModelList.join(', ') || 'Model'}</StyledText>
        </Breadcrumbs>
      </Box>
      <StyledText color={intro ? 'textPrimary' : 'textSecondary'} variant='body4'>
        <DetectLinks content={intro || tbd} />
      </StyledText>
      <Box display='flex' flexWrap='wrap' margin='20px 0'>
        {industryList.length === 0 && <IndustryBullet color='textSecondary' industry={tbd} />}
        {industryList.map((i: Industry) => <IndustryBullet industry={i.industry} key={i.id} />)}
      </Box>
    </Box>
  );
};

export default EntrepreneurIntroPanel;
